import {
  jsonFetchGet,
  jsonFetchPost,
  jsonFetchPut,
} from 'api/jsonFetch/authJsonFetch';

import { CommonErrorBody } from './types';

export type ContractActionName = {
  id: number;
  contractActionName: string;
  contractActionNameId: number;
  hearingDate?: string;
  contractExhibitTypeId: number;
};

export type BadRequestError = {
  status: 400;
  error: CommonErrorBody[];
};

export type ServerContractActionName = {
  id: number;
  contractActionName: string;
  contractActionTypeId: number;
  contractActionNameId: number;
  contractActionTypeName: string;
  contractActionSubStatusId: number;
  contractActionSubStatusName: string;
  hearingDate?: string;
  contractExhibitTypeId: number;
};

export type ContractPostParams = {
  contractExhibitTypeId: number;
  contractActionName: string;
  hearingDate?: string;
};

export type ContractPutParams = ContractPostParams & { id: number };

export const contractActionNames = {
  get: () => {
    return jsonFetchGet<ServerContractActionName[]>(`v1/ContractActionNames`);
  },
  put: (params: ContractPutParams) => {
    return jsonFetchPut<ServerContractActionName, BadRequestError>(
      `v1/ContractActionNames`,
      params,
    );
  },
  post: (params: ContractPostParams) => {
    return jsonFetchPost<ServerContractActionName, BadRequestError>(
      `v1/ContractActionNames`,
      params,
    );
  },
};
